"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonSpecialSentenceWithSentenceWordStatusSchema = exports.NonSpecialSentenceWithSentenceWordStatusSchema = exports.isNonSpecialSentenceWithSpecialWordData = exports.NonSpecialSentenceWithSpecialWordDataSchema = exports.isNonSpecialSentence = exports.NonSpecialSentenceSchema = void 0;
const z = __importStar(require("zod"));
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const sentence_word_types_1 = require("./sentence_word_types");
const special_sentence_types_1 = require("./special_sentence_types");
exports.NonSpecialSentenceSchema = special_sentence_types_1.SpecialSentenceSchema.extend({
    is_special_word_sentence: z.literal(false),
    is_ugc: z.literal(true).optional(),
    sentence_type: z.union([
        z.literal("non_special"),
        z.literal("user_generated"), // TODO: remove once we know this is not being used anymore
    ]),
});
exports.isNonSpecialSentence = type_validation_helpers_1.getTypeValidationFunction(exports.NonSpecialSentenceSchema);
exports.NonSpecialSentenceWithSpecialWordDataSchema = exports.NonSpecialSentenceSchema.extend({
    sentence_words: sentence_word_types_1.SentenceWordWithSpecialWordDataSchema.array(),
});
exports.isNonSpecialSentenceWithSpecialWordData = type_validation_helpers_1.getTypeValidationFunction(exports.NonSpecialSentenceWithSpecialWordDataSchema);
exports.NonSpecialSentenceWithSentenceWordStatusSchema = exports.NonSpecialSentenceSchema.extend({
    sentence_words: sentence_word_types_1.SentenceWordWithStatusSchema.array(),
});
exports.isNonSpecialSentenceWithSentenceWordStatusSchema = type_validation_helpers_1.getTypeValidationFunction(exports.NonSpecialSentenceWithSentenceWordStatusSchema);
//# sourceMappingURL=non_special_sentence_types.js.map